import { Brand } from "../../types/brand";

interface BrandCopyright {
  copyright: string;
  registeredDetails: string[];
}

export const getCopyrightText = (brand: string | undefined): BrandCopyright => {
  switch (brand) {
    case Brand.Littlewoods:
      return {
        copyright: "© The Very Group Limited. All Rights Reserved.",
        registeredDetails: [
          "Shop Direct Home Shopping Limited. Registered number: 4663281. Registered office: 1st Floor, Skyways House, Speke Road, Speke, Liverpool L70 1AB.",
        ],
      };
    case Brand.VeryIE:
      return {
        copyright: "© Shop Direct Ireland Limited. All Rights Reserved.",
        registeredDetails: [
          "Shop Direct Ireland Limited trading as Very is regulated by the Central Bank of Ireland.",
          "Shop Direct Ireland Limited. Registered in Ireland No: 106058. Registered office: Cape House, Westend Office Park, Blanchardstown, D15 Y9DV. VAT No: 4799561M.",
        ],
      };
    default:
      return {
        copyright: "© The Very Group Limited. All Rights Reserved.",
        registeredDetails: [
          "Shop Direct Home Shopping Limited. Registered number: 4663281. Registered office: 1st Floor, Skyways House, Speke Road, Speke, Liverpool L70 1AB.",
        ],
      };
  }
};

export const getCreditInformation = (brand: string | undefined): string => {
  switch (brand) {
    case Brand.Littlewoods:
      return `Credit provided, subject to credit and account status, by Shop Direct Finance Company Limited. Registered office: First Floor, Skyways House, Speke Road, Speke, Liverpool, L70 1AB. Registered number: 4660974. Authorised and regulated by the Financial Conduct Authority. Over 18's only. 1 month = 28 days, 12 months = 12 calendar months.`;

    case Brand.VeryIE:
      return `Credit provided subject to eligibility and lending criteria. Over 18's only. Shop Direct Ireland Limited trading as Very is regulated by the Central Bank of Ireland.`;

    default:
      return `Very Pay credit provided, subject to credit and account status, by Shop Direct Finance Company Limited. Registered office: First Floor, Skyways House, Speke Road, Speke, Liverpool, L70 1AB. Registered number: 4660974. Authorised and regulated by the Financial Conduct Authority. Over 18's only.`;
  }
};
